import _extends from "@babel/runtime/helpers/extends";
import { Modal } from '@wix/design-system';
import { packagePickerTranslationsExtension } from '@wix/package-picker-shared';
import { ApisClientProvider } from '@wix/premium-fed-sdk/@apis-infra-react';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { createPremiumModule, modalsExtension } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
import { DoublePurchaseExtension } from '../../extensions';
import { DoublePurchaseModal } from './components/DoublePurchaseModal/DoublePurchaseModal';
import { DoublePurchaseModuleContextExtension } from './context.extension';
export const DoublePurchaseModule = createPremiumModule('double-purchase-module', [DoublePurchaseModuleContextExtension, packagePickerTranslationsExtension, DoublePurchaseExtension, modalsExtension({
  DoublePurchaseModal: _ref => {
    let {
      onClose,
      onConfirm,
      onLoad,
      ...props
    } = _ref;
    return /*#__PURE__*/React.createElement(Modal, _extends({
      shouldCloseOnOverlayClick: true
    }, props), /*#__PURE__*/React.createElement(DoublePurchaseModal, {
      onClose: onClose,
      onConfirm: onConfirm,
      onLoad: onLoad
    }));
  }
})], module => {
  return {
    Provider: _ref2 => {
      let {
        children
      } = _ref2;
      return /*#__PURE__*/React.createElement(ApisClientProvider, null, /*#__PURE__*/React.createElement(module.SDK.Modals, null), children);
    },
    SDK: {
      ...module.SDK,
      modalsController: module.internals.modalsController,
      useCheckDoublePurchase: () => {
        const {
          siteGuid,
          productTypeId
        } = DoublePurchaseModule.internals.useContext();
        const {
          httpClient
        } = usePremiumEssentialsContext();
        const queries = httpClient && DoublePurchaseModule.SDK.doublePurchaseApiClient.queries({
          httpClient
        });
        const checkDoublePurchase = queries && (async () => {
          return queries.checkDoublePurchase({
            siteGuid,
            productTypeId
          });
        });
        return {
          checkDoublePurchase
        };
      }
    }
  };
});
//# sourceMappingURL=double-purchase.module.js.map